<template>
<div class="overlay centered">
    <section>
        <img src="/assets/img/arrow-target.svg">
    </section>
    <section>
        <h2 class="centered text">
            Oops, this probably isn't where you were aiming...
        </h2>
    </section>
    <section>
        <div class="centered text">
            You hit the right place, just not the right page.
        </div>
    </section>
    <section>
        <router-link class="button pink" to="/">
            Try Our Main Page
        </router-link>
    </section>
</div>
</template>
<script>
export default {
    name: 'NotFound'
};
</script>
